import { defineAsyncComponent } from "vue"

export default {
  Article: defineAsyncComponent(() =>
    import("@soenergy/frontend-library/src/components/Article")
  ),
  OrderedList: defineAsyncComponent(() =>
    import("@soenergy/frontend-library/src/components/OrderedList")
  ),
  OrderedListItem: defineAsyncComponent(() =>
    import("@soenergy/frontend-library/src/components/OrderedListItem")
  ),
  ReferShare: defineAsyncComponent(() => import("./ReferShare")),
  ReferralList: defineAsyncComponent(() => import("./ReferralList")),
  ReferHowItWorks: defineAsyncComponent(() => import("./ReferHowItWorks")),
  TwoColumnBlock: defineAsyncComponent(() =>
    import("@soenergy/frontend-library/src/components/TwoColumnBlock")
  ),
  UspBlockDetailed: defineAsyncComponent(() =>
    import("@soenergy/frontend-library/src/components/UspBlockDetailed")
  ),
  InfoCard: defineAsyncComponent(() =>
    import("@soenergy/frontend-library/src/components/InfoCard")
  ),
  InfoCardsBlock: defineAsyncComponent(() =>
    import("@soenergy/frontend-library/src/components/InfoCardsBlock")
  ),
  TwoColumnBlockStack: defineAsyncComponent(() =>
    import("@soenergy/frontend-library/src/components/TwoColumnBlockStack")
  ),
  TwoColumnHero: defineAsyncComponent(() =>
    import("@soenergy/frontend-library/src/components/TwoColumnHero")
  ),
  ReadMoreCard: defineAsyncComponent(() =>
    import("@soenergy/frontend-library/src/components/ReadMoreCard")
  ),
  AdvancedArticle: defineAsyncComponent(() =>
    import("@soenergy/frontend-library/src/components/AdvancedArticle")
  ),
  HeroBannerGeneral: defineAsyncComponent(() =>
    import("@soenergy/frontend-library/src/components/HeroBannerGeneral")
  ),
  Carousel: defineAsyncComponent(() =>
    import("@soenergy/frontend-library/src/components/Carousel")
  ),
  TrustpilotCard: defineAsyncComponent(() =>
    import("@soenergy/frontend-library/src/components/TrustpilotCard")
  ),
}
